import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import './index.css';
import "@fortawesome/fontawesome-free/css/all.min.css"
import { QueryClient ,QueryClientProvider} from 'react-query';
import { ReactQueryDevtools}from 'react-query/devtools' 
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const query = new QueryClient;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={query}>
    <App />
    <ReactQueryDevtools />
    </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
